/**
 * Pluralise a string based on a number:
 * singular: Downloading Asset,
 * plural: Downloading Assets,
 * zero: No Assets to Download
 */

export const formatNumber = (n: number) =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const pluralise = (
  number: number | unknown[],
  singular: string,
  plural: string,
  zero?: string | undefined,
): string => {
  const finalNumber: number = Array.isArray(number) ? number.length : number;
  const finalNumberFormatted = formatNumber(finalNumber);
  return (
    finalNumber === 1
      ? singular
      : !finalNumber && zero !== undefined
        ? zero
        : plural || singular
  ).replace('{x}', finalNumberFormatted);
};

export const pluraliseS = (
  number: number | unknown[],
  string: string,
  lowercase: boolean = false,
): string => {
  const finalNumber: number = Array.isArray(number) ? number.length : number;
  const finalNumberFormatted = formatNumber(finalNumber);
  return !finalNumber
    ? `${lowercase ? 'no' : 'No'} ${string}s`
    : `${finalNumberFormatted} ${string}${finalNumber !== 1 ? 's' : ''}`;
};

export const pluraliseXOfX = (
  number: number,
  total: number,
  singular: string,
  plural: string,
  zero?: string | undefined,
  divider: string = ' of ',
): string => {
  const numbersEqual = total === number;
  const finalNumber = !number || numbersEqual ? number : total;
  const formatted = numbersEqual
    ? formatNumber(number)
    : `${formatNumber(number)}${divider}${formatNumber(total)}`;
  return (
    finalNumber === 1
      ? singular
      : !total && zero !== undefined
        ? zero
        : plural || singular
  ).replace('{x}', formatted);
};
